import React from 'react';
import styled from 'styled-components';

import { Meal } from '@lt/components/icons-react/userflow';

const HotelRoomCardSkeleton = (): JSX.Element => (
  <HotelRoomCardSkeletonContainer>
    <StyledHotelImageSkeleton />
    <StyledHotelSkeletonContent>
      <StyledHorizontalLine $marginBottom={19} $width={187} />
      <StyledHorizontalLine $marginBottom={17} $width={105} />
      <StyledMealWithLineBlock>
        <Meal width={10} />
        <StyledHorizontalLine $marginBottom={0} $width={105} />
      </StyledMealWithLineBlock>
    </StyledHotelSkeletonContent>
  </HotelRoomCardSkeletonContainer>
);

const HotelRoomCardSkeletonContainer = styled.div`
  display: flex;
  flex: 1;

  min-height: 110px;
  margin: 4px;

  @media (min-width: 476px) {
    min-height: 131px;
  }
`;

const StyledHotelSkeletonContent = styled.div`
  padding: 8px 16px;
`;

const StyledHotelImageSkeleton = styled.div`
  background: #e5e5e5;

  width: 90px;

  @media (min-width: 476px) {
    width: 160px;
  }
`;

const StyledMealWithLineBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
`;

const StyledHorizontalLine = styled.div<{
  $marginBottom: number;
  $width: number;
}>`
  width: ${({ $width }) => $width}px;
  color: #e6e6e6;
  margin-bottom: ${({ $marginBottom }) => $marginBottom}px;

  &:after {
    content: '';
    display: block;
    border-bottom: 1px solid;
  }
`;

export default HotelRoomCardSkeleton;
